module.exports = __webpack_public_path__ + "img/channel.b3c3bcb7.png";